import React from 'react';

interface Props {}

const AuthorAvatar = (props: Props) => {
    return (
        <svg width="88" height="88" viewBox="0 0 88 88" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="44" cy="44" r="44" fill="#B2FCE4" />
            <path
                d="M44 45.75C48.8325 45.75 52.75 41.8325 52.75 37C52.75 32.1675 48.8325 28.25 44 28.25C39.1675 28.25 35.25 32.1675 35.25 37C35.25 41.8325 39.1675 45.75 44 45.75Z"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M61.3351 63.6741C59.7699 60.4037 57.3115 57.6429 54.2441 55.7102C51.1767 53.7775 47.6251 52.752 43.9996 52.752C40.374 52.752 36.8224 53.7775 33.7549 55.7102C30.6874 57.6429 28.2292 60.4037 26.6641 63.6741"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M44 70.25C58.4973 70.25 70.25 58.4973 70.25 44C70.25 29.5025 58.4973 17.75 44 17.75C29.5025 17.75 17.75 29.5025 17.75 44C17.75 58.4973 29.5025 70.25 44 70.25Z"
                stroke="black"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default AuthorAvatar;
